import { IdentityConfigConversation } from '../../identity/identity-config/identity-config-conversation/identity-config-conversation';

export const defaultIdentityConfigConversation = new IdentityConfigConversation({ captureTarget: undefined });
